import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/**
 * Keep project/prototype URLs on the pretty code, never the UUID. Once the
 * project has loaded and we know its `code`, if the URL still carries the UUID
 * (or a lower-cased code) in the project segment, replace it with the code.
 *
 * `param` is the current `:projectId`/`:id` route segment; `code` is the loaded
 * project's code. Only the first occurrence of the segment is swapped, so deeper
 * segments (e.g. `/loops/:loopId`) are untouched. Guarded on inequality so it
 * never loops.
 */
export function useCanonicalProjectRef(param: string, code?: string | null): void {
  const navigate = useNavigate();
  const { pathname, search } = useLocation();
  useEffect(() => {
    if (code && param && param !== code) {
      navigate(pathname.replace(`/${param}`, `/${code}`) + search, { replace: true });
    }
  }, [code, param, pathname, search, navigate]);
}
